<template>
	<div class="container-list  flex-column" style="height: 100%;">
		<ul class="tab-wrap" style="position:relative" v-if="!$route.query.index && $route.query.index !== 0">
			<li
				:class="`tab-btn ${nowIndex == index && 'active'}`"
				@click="changeTab(index, tab)"
				v-for="(tab, index) in tabList"
				:key="index"
				v-if="
					!($store.state.userInfo.tongxin == true && index >= 4 && index <= 5) &&
						!($store.state.userInfo.tongxin == false && index > 7 && index <= 8) &&
						!($store.state.userInfo.tongxin && index >= 7 && index <= 10)
				"
			>
				{{ tab.title }}
			</li>
			<!-- v-hasPermi="tab.permission" -->

			<li>
				<el-button
					class=""
					@click="$store.commit('swithWaring', 0)"
					v-if="(nowWarning || this.isWaring) && !$route.query.index && $route.query.index !== 0"
					size="small"
					type="danger"
					style="position:absolute;right:0px;bottom:20px"
				>
					关闭报警
				</el-button>
			</li>
		</ul>
		<el-button
			class=""
			@click="$store.commit('swithWaring', 0)"
			v-if="(nowWarning || this.isWaring) && !(!$route.query.index && $route.query.index !== 0)"
			size="small"
			type="danger"
			style="position:absolute;right:20px;"
		>
			关闭报警
		</el-button>
		<el-button
			class=""
			@click="$store.commit('swithWaring', 0)"
			v-if="(nowWarning || this.isWaring) && !(!$route.query.index && $route.query.index !== 0)"
			size="small"
			type="danger"
			style="position:absolute;right:20px;"
		>
			关闭报警
		</el-button>

		<div class="flex" style="flex: 1;">
			<unitList
				v-show="!($store.state.user.userInfo.natureId == 2)"
				@select="getUnit"
				@getFirst="getOne"
				:isbim="nowIndex == 9 || nowIndex === 10 ? true : false"
				v-if="!(nowIndex == 5 || nowIndex == 6 || nowIndex == 8 || nowIndex == 0 || nowIndex == 11)"
			></unitList>
			<div class="flex1" style="height39.5vw;overflow:auto">
				<tab1 v-if="nowIndex == 0" :cpNum="cpNum" ref="fire"></tab1>
				<tab2 v-if="nowIndex == 1" :cpNum="cpNum" ref="water"></tab2>
				<tab3 v-if="nowIndex == 2" :cpNum="cpNum" ref="elec"></tab3>
				<tab4 v-if="nowIndex == 3" :cpNum="cpNum" ref="video"></tab4>
				<tab5 v-if="nowIndex == 4" :cpNum="cpNum" :nowDevice="nowDeviceMessage" ref="waterbeng"></tab5>

				<tab6 v-if="nowIndex == 5" :cpNum="cpNum" ref="paiyan" :nowDevice="nowDeviceMessage"></tab6>
				<tab11 v-if="nowIndex == 6" :cpNum="cpNum"></tab11>

				<tab7 v-if="nowIndex == 7" :cpNum="cpNum" ref="wuxian"></tab7>
				<tab8 v-if="nowIndex == 8" :cpNum="cpNum" ref="yangan"></tab8>
				<tab9 v-if="nowIndex == 9" :cpNum="cpNum"></tab9>

				<tab10 v-if="nowIndex == 10" :cpNum="cpNum"></tab10>

				<tab12 v-if="nowIndex == 11" :cpNum="cpNum"></tab12>
				<tab13 v-if="nowIndex == 12" :cpNum="cpNum"></tab13>
				<tab14 v-if="nowIndex == 13" :cpNum="cpNum"></tab14>

				<tab15 v-if="nowIndex == 14" :cpNum="cpNum"></tab15>
				<tab16 v-if="nowIndex == 15" :cpNum="cpNum"></tab16>
			</div>
		</div>
	</div>
</template>
<script>
	import unitList from "@/components/unitList";
	import tab1 from "./tab1.vue";
	import tab2 from "./tab2.vue";
	import tab3 from "./tab3.vue";
	import tab4 from "./tab4.vue";
	import tab5 from "./tab5.vue";
	import tab6 from "./tab6.vue";
	import tab7 from "./tab7.vue";
	import tab8 from "./tab8-bei.vue";
	import tab9 from "./tab9.vue";
	import tab10 from "./tab10.vue";
	import tab11 from "./tab11.vue";
	import tab12 from "./tab12.vue";
	import tab13 from "./tab13.vue";
	import tab14 from "./tab14.vue";
	import tab15 from "./tab15.vue";
	import tab16 from "./tab16.vue";

	import config from "@/utils/config.js";

	import { mapState } from "vuex";
	if (process.env.NODE_ENV == "development") {
		//本地
		var wsUrl = config.wsUrltest;
	} else if (process.env.NODE_ENV == "production") {
		//线上
		var wsUrl = config.wsUrl;
	}
	export default {
		name: "facility",

		components: {
			unitList,
			tab1,
			tab2,
			tab3,
			tab4,
			tab5,
			tab6,
			tab7,
			tab8,
			tab9,
			tab10,
			tab11,
			tab12,
			tab13,
			tab14,
			tab15,
			tab16,
		},
		props: ["homeComp"],
		data() {
			return {
				nowIndex: 0,
				cpNum: "",
				nowid: "",
				tabList: [
					{ title: "报警系统", permission: [] },
					{ title: "水系统", permission: [] },
					{ title: "电气监控", permission: [] },
					{ title: "视频监控", permission: [] },
					{ title: "消防水泵", permission: [] },
					{ title: "防排烟风机", permission: [] },
					{ title: "防火门", permission: [] },
					{ title: "无线燃气", permission: [] },
					{ title: "无线烟感", permission: [] },
					{ title: "三维展示", permission: [] },
					{ title: "违停车辆", permission: [] },
					{ title: "应急照明", permission: [] },
					{ title: "风机检测", permission: [] },
					{ title: "室外消火栓", permission: [] },
					{ title: "消防电源", permission: [] },
					{ title: "气体灭火", permission: [] },
				],
				// tabList: [
				//   '报警系统',
				//   '水系统',
				//   '电气监控',
				//   '视频监控',
				//   '消防水泵',
				//   '防排烟风机',
				//   '防火门',
				//   '无线燃气',
				//   '无线烟感',
				//   '三维展示',
				//   '违停车辆',
				//   '应急照明',
				//   '风机检测',
				//   '室外消火栓',
				//   '消防电源',
				//   '气体灭火',
				// ],
				company: "",
				nowMessage: "",
				nowDeviceMessage: "",
				nowWarning: false,
				activeName: "first",
			};
		},
		provide() {
			// 使用函数的形式，可以访问到 `this`
			return {
				cpNum: this.cpNum,
			};
		},
		computed: {
			...mapState(["isMute", "isWaring", "bjList", "isLoop", "showFire", "alarmDtItem"]),
		},
		created() {
			this.getOne();
			if (this.$route.query.index == 0) {
				this.nowIndex = 8;
			}
			this.getWarning(this.isWaring);
		},
		mounted() {
			var me = this;
			var ws;
			var lockReconnect = false; //避免重复连接
			// alert(document.deviceWS)
			createWebSocket(); // 创建websocket

			function createWebSocket() {
				try {
					me.ws = new WebSocket(wsUrl);
					websocketInit();
				} catch (e) {
					log("catch");
					websocketReconnect(wsUrl);
				}
			}

			function websocketInit() {
				console.log("初始化");
				// 建立 web socket 连接成功触发事件
				me.ws.onopen = function(evt) {
					onOpen(evt);
				};
				// 断开 web socket 连接成功触发事件
				me.ws.onclose = function(evt) {
					websocketReconnect(wsUrl);
					onClose(evt);
				};
				// 接收服务端数据时触发事件
				me.ws.onmessage = function(evt) {
					onMessage(evt);
				};
				// 通信发生错误时触发
				me.ws.onerror = function(evt) {
					websocketReconnect(wsUrl);
					onError(evt);
				};
			}

			function onOpen(evt) {
				log("建立设备链接");
				//心跳检测重置
				if (!me.heartCheck.isStart) {
					me.heartCheck.start();
				}
				document.deviceWS = me.ws;
			}

			function onClose(evt) {}

			function onMessage(evt) {
				// console.log(evt)
				if (evt.data === '"shoudao"') {
				} else {
					//！！这里接受消息 写东西
					var data = JSON.parse(evt.data);
					// console.log(data);
					setTimeout(() => {
						me.nowDeviceMessage = data;
					}, 1000);
				}
				//拿到任何消息都说明当前连接是正常的
				me.heartCheck.start();
			}

			function websocketReconnect(url) {
				if (lockReconnect) {
					// 是否已经执行重连
					return;
				}
				lockReconnect = true;
				//没连接上会一直重连，设置延迟避免请求过多
				tt && clearTimeout(tt);
				var tt = setTimeout(function() {
					createWebSocket(url);
					lockReconnect = false;
				}, 5000);
			}

			//心跳检测
			me.heartCheck = {
				timeout: 5000,
				timeoutObj: null,
				serverTimeoutObj: null,
				isStart: false,
				start: function() {
					var self = this;
					this.isStart = true;
					this.timeoutObj && clearTimeout(this.timeoutObj);
					this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
					this.timeoutObj = setTimeout(function() {
						//发送测试信息，后端收到后，返回一个消息，
						me.ws.send("fasong");
						self.serverTimeoutObj = setTimeout(function() {
							me.ws.close();
						}, self.timeout);
					}, this.timeout);
				},
			};

			function onError(evt) {
				log("通信错误：" + evt.data);
			}
		},
		watch: {
			bjList(it) {
				this.nowMessage = it[0];
			},
			isWaring(val) {
				this.nowWarning = val;
				this.getWarning(val);
				//  for(var i in this.$refs){
				//   if(this.$refs[i]){
				//     this.$refs[i].changeFireStatus(val,this.nowMessage)
				//   }
				//  }
				//  console.log(this.$refs['fire'])
			},
		},
		beforeDestroy() {
			this.ws.close();
			this.ws.onclose = function() {
				console.log("设备关闭");
			};
		},
		methods: {
			// 接受报警
			getWarning(val) {
				// console.log(111 + "," + val);
				if (val || this.isWaring) {
					// 报警中 下发给组件此次报警
					//  查找最近的一条 超限报警
					this.nowMessage = this.$store.state.bjList[0];
				} else {
					this.nowMessage = "";
				}

				for (var i in this.$refs) {
					if (this.$refs[i]) {
						if (this.$refs[i].changeFireStatus) this.$refs[i].changeFireStatus(val, this.nowMessage);
					}
				}
			},

			changeTab(index, it) {
				this.activeName = index;
				this.nowIndex = index;
				this.nowid = it.tr_role_key;
				setTimeout(() => {
					this.getWarning(this.isWaring);
				}, 100);
			},
			getOne(val) {
				this.cpNum = val;
			},
			getUnit(val) {
				this.cpNum = val;
			},
		},
	};
</script>
<style lang="scss">
	.flex-column {
		display: flex;
		flex-direction: column;
	}
	.f-list {
		flex-wrap: wrap;

		li {
			width: 240px;
			height: 280px;
			margin-right: 40px;
			margin-bottom: 40px;
		}
	}

	.com-warp {
		margin-top: 10px;

		li {
			font-size: 18px;
			line-height: 34px;
			color: #333;

			padding-left: 10px;
			opacity: 0.7;

			&:nth-child(odd) {
				background: #efeeff;
			}
		}
	}

	.tab-wrap {
		padding-bottom: 20px;
		border-bottom: 1px solid #ddd;
		margin-bottom: 10px;
	}

	.f-left {
		width: 260px;
		border: 1px solid #ddd;
		border-radius: 10px;
		padding: 10px;
		height: 600px;
		margin-right: 30px;
	}
</style>
